<template>
    <div class="select-box" v-if="isShow">
        <ul>
            <li class="text-select"
                v-for="(item,index) in options"
                :key="index" @click="$emit('change', item)"
                :class="{'active': defaultVal===item.value}">{{ item.value }}</li>
        </ul>
    </div>
</template>
<script>
    export default {
        name: 'ComponentSelect',
        props: {
            defaultVal: { type: String, default: '' },
            options: { type: [Array, Object],
                       default: () => [
                           { key: '', value: '全部' },
                           { key: 1, value: '课程' },
                           { key: 2, value: '专题' },
                           { key: 3, value: '考试' },
                           { key: 4, value: '调研' },
                           { key: 5, value: '培训' },
                           { key: 6, value: '直播' },
                           { key: 7, value: '认证考试' }
                       ]
            }
        },
        data() {
            return {
                isShow: true
            };
        },
        methods: {
            hide() {
                this.isShow = false;
                setTimeout(() => {
                    this.isShow = true;
                }, 0);
            }
        }
    };
</script>
